export default {
  support_contacts: {
    title: 'サポート',
    payments: 'お支払いに関するお問い合わせ：{finance_email}',
    other: 'その他のお問い合わせは{link}へご連絡ください',
    support_link: 'サポート'
  }
};
